import { ValidatorRules } from '../../../../../tradebuilder-v2/util/validator'
import { SetEconomicsFormState } from '../set-economics-slice'

export const setEconomicsRules: ValidatorRules<SetEconomicsFormState> = {
  feeRates: (state: SetEconomicsFormState) => {
    const fees = state.noteFees
      .map(x => x.feeRate)
      .concat(state.portfolioFees.map(x => x.feeRate))
      .concat(state.strategyFees.map(x => x.feeRate))
    return {
      isValid: !(fees.some(x => x <= 0) || fees.some(x => x > 0.2)),
      message: 'All fee rates must be greater than 0% and less than 20%'
    }
  }
}
